export default "<div class=\"add\" (click)=\"onAddClick()\">\r\n    <div>\r\n        <mat-icon>add_circle</mat-icon>\r\n    </div>\r\n</div>";